<div class="vc-chart-wrapper-container vc-form-container" [style.height]="contentHeight">
    <div class="vc-chart-wrapper-header">
        <h2 *ngIf="title" class="vc-chart-wrapper-title title-l">{{ title }}</h2>
        <ng-content *ngIf="!title" select="[chartActionsTitle]"></ng-content>
        <ng-content select="[chartActionsRightSide]"></ng-content>
    </div>
    <ng-content></ng-content>
</div>
